// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Routes Modal Styles
 *
 * Uses centralised theme variables from theme.css
 */

/* Routes Modal Overlay */
.routes-modal-overlay {
  position: fixed;
  inset: 0;
  background: var(--cfn-bg-overlay);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 1rem;
  animation: routes-modal-fade-in 0.2s ease;
}

@keyframes routes-modal-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Modal Container */
.routes-modal {
  background: var(--cfn-modal-bg);
  border-radius: 16px;
  border: 1px solid var(--cfn-border);
  box-shadow: var(--cfn-modal-shadow);
  width: min(960px, 100%);
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  animation: routes-modal-slide-up 0.3s ease;
  overflow: hidden;
}

@keyframes routes-modal-slide-up {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Header */
.routes-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid var(--cfn-border-muted);
  background: var(--cfn-modal-header-bg);
}

.routes-modal__title {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--cfn-text-primary);
  display: flex;
  align-items: center;
  gap: 0.625rem;
}

.routes-modal__title-icon {
  color: var(--cfn-accent-primary);
  flex-shrink: 0;
}

.routes-modal__close {
  background: transparent;
  border: none;
  color: var(--cfn-text-muted);
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.25rem;
  transition: color 0.2s ease;
  line-height: 1;
}

.routes-modal__close:hover {
  color: var(--cfn-text-primary);
}

/* Search */
.routes-modal__search {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--cfn-border-muted);
  background: var(--cfn-bg-tertiary);
}

.routes-modal__search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.routes-modal__search-icon {
  position: absolute;
  left: 1rem;
  color: var(--cfn-text-disabled);
  font-size: 1rem;
  pointer-events: none;
}

.routes-modal__search-input {
  width: 100%;
  padding: 0.75rem 1rem 0.75rem 2.75rem;
  background: var(--cfn-input-bg);
  border: 1px solid var(--cfn-input-border);
  border-radius: 8px;
  color: var(--cfn-input-text);
  font-size: 0.9375rem;
  transition: all 0.2s ease;
}

.routes-modal__search-input::-moz-placeholder {
  color: var(--cfn-input-placeholder);
}

.routes-modal__search-input::placeholder {
  color: var(--cfn-input-placeholder);
}

.routes-modal__search-input:focus {
  outline: none;
  border-color: var(--cfn-input-focus-border);
  box-shadow: 0 0 0 3px var(--cfn-input-focus-ring);
}

.routes-modal__search-clear {
  position: absolute;
  right: 0.75rem;
  background: transparent;
  border: none;
  color: var(--cfn-text-disabled);
  font-size: 1.125rem;
  cursor: pointer;
  padding: 0.25rem;
  transition: color 0.2s ease;
  line-height: 1;
}

.routes-modal__search-clear:hover {
  color: var(--cfn-text-muted);
}

/* Body */
.routes-modal__body {
  flex: 1;
  overflow-y: auto;
  min-height: 300px;
  scrollbar-width: thin;
  scrollbar-color: var(--cfn-scrollbar-thumb) var(--cfn-scrollbar-track);
}

.routes-modal__body::-webkit-scrollbar {
  width: 8px;
}

.routes-modal__body::-webkit-scrollbar-track {
  background: var(--cfn-scrollbar-track);
}

.routes-modal__body::-webkit-scrollbar-thumb {
  background: var(--cfn-scrollbar-thumb);
  border-radius: 4px;
}

.routes-modal__body::-webkit-scrollbar-thumb:hover {
  background: var(--cfn-scrollbar-thumb-hover);
}

/* Loading State */
.routes-modal__loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  gap: 1rem;
  color: var(--cfn-text-secondary);
}

.routes-modal__spinner {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 4px solid var(--cfn-spinner-track);
  border-top-color: var(--cfn-spinner-fill);
  animation: routes-modal-spin 1s linear infinite;
}

@keyframes routes-modal-spin {
  to { transform: rotate(360deg); }
}

/* Error State */
.routes-modal__error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  gap: 1rem;
  color: var(--cfn-danger-text);
  text-align: center;
}

.routes-modal__error-icon {
  opacity: 0.5;
  flex-shrink: 0;
}

.routes-modal__retry-btn {
  margin-top: 0.5rem;
  padding: 0.5rem 1.25rem;
  background: var(--cfn-danger-muted);
  border: 1px solid var(--cfn-danger);
  border-radius: 6px;
  color: var(--cfn-danger-text);
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.routes-modal__retry-btn:hover {
  background: var(--cfn-btn-danger-hover-bg);
}

/* Empty State */
.routes-modal__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  gap: 1rem;
  color: var(--cfn-text-muted);
  text-align: center;
}

.routes-modal__empty-icon {
  opacity: 0.5;
  flex-shrink: 0;
}

/* Table */
.routes-modal__table-wrapper {
  overflow-x: auto;
}

.routes-modal__table {
  width: 100%;
  border-collapse: collapse;
}

.routes-modal__table thead {
  background: var(--cfn-table-header-bg);
  border-bottom: 2px solid var(--cfn-border);
  position: sticky;
  top: 0;
  z-index: 1;
}

.routes-modal__table th {
  padding: 0.875rem 1.25rem;
  text-align: left;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--cfn-text-secondary);
}

.routes-modal__table tbody tr {
  border-bottom: 1px solid var(--cfn-border-muted);
  transition: background 0.15s ease;
}

.routes-modal__table tbody tr:hover {
  background: var(--cfn-table-row-hover);
}

.routes-modal__table td {
  padding: 1rem 1.25rem;
  color: var(--cfn-text-secondary);
  font-size: 0.9375rem;
}

.routes-modal__ref {
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-weight: 600;
  color: var(--cfn-accent-primary-text);
}

.routes-modal__description {
  color: var(--cfn-text-secondary);
}

.routes-modal__actions-col {
  width: 200px;
  text-align: right;
}

/* Action Buttons */
.routes-modal__actions {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
}

.routes-modal__action-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.routes-modal__action-btn svg {
  flex-shrink: 0;
}

.routes-modal__spinner-icon {
  animation: routes-modal-spin 1s linear infinite;
}

.routes-modal__action-btn--edit {
  background: var(--cfn-accent-primary-muted);
  border-color: var(--cfn-accent-primary);
  color: var(--cfn-accent-primary-text);
}

.routes-modal__action-btn--edit:hover {
  background: var(--cfn-btn-primary-hover-bg);
  transform: translateY(-1px);
  box-shadow: var(--cfn-shadow-md);
}

.routes-modal__action-btn--add {
  background: var(--cfn-success-muted);
  border-color: var(--cfn-success);
  color: var(--cfn-success-text);
}

.routes-modal__action-btn--add:hover {
  background: rgba(16, 185, 129, 0.3);
  transform: translateY(-1px);
  box-shadow: var(--cfn-shadow-md);
}

.routes-modal__action-btn--on-map {
  background: var(--cfn-bg-tertiary);
  border-color: var(--cfn-border-muted);
  color: var(--cfn-text-muted);
  cursor: default;
}

.routes-modal__action-btn--on-map:hover {
  transform: none;
  box-shadow: none;
  background: var(--cfn-bg-tertiary);
}

/* Footer & Pagination */
.routes-modal__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--cfn-border-muted);
  background: var(--cfn-modal-footer-bg);
  gap: 1rem;
  flex-wrap: wrap;
}

.routes-modal__pagination-info {
  font-size: 0.875rem;
  color: var(--cfn-text-muted);
}

.routes-modal__pagination {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.routes-modal__page-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--cfn-input-bg);
  border: 1px solid var(--cfn-border);
  border-radius: 6px;
  color: var(--cfn-text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
}

.routes-modal__page-btn:hover:not(:disabled) {
  background: var(--cfn-accent-primary-muted);
  border-color: var(--cfn-accent-primary);
  color: var(--cfn-text-primary);
}

.routes-modal__page-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.routes-modal__page-numbers {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.routes-modal__page-number {
  min-width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.5rem;
  background: var(--cfn-input-bg);
  border: 1px solid var(--cfn-border);
  border-radius: 6px;
  color: var(--cfn-text-secondary);
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.routes-modal__page-number:hover:not(.routes-modal__page-number--active) {
  background: var(--cfn-accent-primary-muted);
  border-color: var(--cfn-accent-primary);
}

.routes-modal__page-number--active {
  background: var(--cfn-btn-primary-bg);
  border-color: var(--cfn-accent-primary);
  color: var(--cfn-btn-primary-text);
  cursor: default;
}

.routes-modal__page-ellipsis {
  padding: 0 0.25rem;
  color: var(--cfn-text-disabled);
  font-size: 0.875rem;
}

/* Responsive */
@media (max-width: 768px) {
  .routes-modal {
    max-height: 90vh;
    width: 100%;
  }

  .routes-modal__table th,
  .routes-modal__table td {
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
  }

  .routes-modal__actions {
    flex-direction: column;
    width: 100%;
  }

  .routes-modal__action-btn {
    width: 100%;
    justify-content: center;
  }

  .routes-modal__footer {
    flex-direction: column;
    align-items: stretch;
  }

  .routes-modal__pagination {
    justify-content: center;
  }

  .routes-modal__pagination-info {
    text-align: center;
  }
}

/* Short landscape: bound the routes modal to the real viewport. The body
   (.routes-modal__body) already scrolls, so this just keeps it fully on-screen. */
@media (orientation: landscape) and (max-height: 600px) {
  .routes-modal {
    max-height: calc(var(--app-height, 100dvh) - 20px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/home/styles/routes-modal.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,yBAAyB;AACzB;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,oBAAoB;AACpB;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,mCAAmC;EACnC,mCAAmC;EACnC,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gDAAgD;EAChD,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,+BAA+B;EAC/B,yCAAyC;EACzC,kBAAkB;EAClB,4BAA4B;EAC5B,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAFA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,SAAS;AACT;EACE,OAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,sEAAsE;AACxE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,yCAAyC;EACzC,+CAA+C;AACjD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;EACnC,mCAAmC;EACnC,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gDAAgD;EAChD,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,2DAA2D;EAC3D,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,6CAA6C;EAC7C,sCAAsC;EACtC,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,mCAAmC;EACnC,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,+BAA+B;EAC/B,mCAAmC;EACnC,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;;IAEE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;kFACkF;AAClF;EACE;IACE,kDAAkD;EACpD;AACF","sourcesContent":["/**\n * Routes Modal Styles\n *\n * Uses centralised theme variables from theme.css\n */\n\n/* Routes Modal Overlay */\n.routes-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: var(--cfn-bg-overlay);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 1rem;\n  animation: routes-modal-fade-in 0.2s ease;\n}\n\n@keyframes routes-modal-fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* Modal Container */\n.routes-modal {\n  background: var(--cfn-modal-bg);\n  border-radius: 16px;\n  border: 1px solid var(--cfn-border);\n  box-shadow: var(--cfn-modal-shadow);\n  width: min(960px, 100%);\n  max-height: 85vh;\n  display: flex;\n  flex-direction: column;\n  animation: routes-modal-slide-up 0.3s ease;\n  overflow: hidden;\n}\n\n@keyframes routes-modal-slide-up {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Header */\n.routes-modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid var(--cfn-border-muted);\n  background: var(--cfn-modal-header-bg);\n}\n\n.routes-modal__title {\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: var(--cfn-text-primary);\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n}\n\n.routes-modal__title-icon {\n  color: var(--cfn-accent-primary);\n  flex-shrink: 0;\n}\n\n.routes-modal__close {\n  background: transparent;\n  border: none;\n  color: var(--cfn-text-muted);\n  font-size: 1.5rem;\n  cursor: pointer;\n  padding: 0.25rem;\n  transition: color 0.2s ease;\n  line-height: 1;\n}\n\n.routes-modal__close:hover {\n  color: var(--cfn-text-primary);\n}\n\n/* Search */\n.routes-modal__search {\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid var(--cfn-border-muted);\n  background: var(--cfn-bg-tertiary);\n}\n\n.routes-modal__search-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.routes-modal__search-icon {\n  position: absolute;\n  left: 1rem;\n  color: var(--cfn-text-disabled);\n  font-size: 1rem;\n  pointer-events: none;\n}\n\n.routes-modal__search-input {\n  width: 100%;\n  padding: 0.75rem 1rem 0.75rem 2.75rem;\n  background: var(--cfn-input-bg);\n  border: 1px solid var(--cfn-input-border);\n  border-radius: 8px;\n  color: var(--cfn-input-text);\n  font-size: 0.9375rem;\n  transition: all 0.2s ease;\n}\n\n.routes-modal__search-input::placeholder {\n  color: var(--cfn-input-placeholder);\n}\n\n.routes-modal__search-input:focus {\n  outline: none;\n  border-color: var(--cfn-input-focus-border);\n  box-shadow: 0 0 0 3px var(--cfn-input-focus-ring);\n}\n\n.routes-modal__search-clear {\n  position: absolute;\n  right: 0.75rem;\n  background: transparent;\n  border: none;\n  color: var(--cfn-text-disabled);\n  font-size: 1.125rem;\n  cursor: pointer;\n  padding: 0.25rem;\n  transition: color 0.2s ease;\n  line-height: 1;\n}\n\n.routes-modal__search-clear:hover {\n  color: var(--cfn-text-muted);\n}\n\n/* Body */\n.routes-modal__body {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 300px;\n  scrollbar-width: thin;\n  scrollbar-color: var(--cfn-scrollbar-thumb) var(--cfn-scrollbar-track);\n}\n\n.routes-modal__body::-webkit-scrollbar {\n  width: 8px;\n}\n\n.routes-modal__body::-webkit-scrollbar-track {\n  background: var(--cfn-scrollbar-track);\n}\n\n.routes-modal__body::-webkit-scrollbar-thumb {\n  background: var(--cfn-scrollbar-thumb);\n  border-radius: 4px;\n}\n\n.routes-modal__body::-webkit-scrollbar-thumb:hover {\n  background: var(--cfn-scrollbar-thumb-hover);\n}\n\n/* Loading State */\n.routes-modal__loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  gap: 1rem;\n  color: var(--cfn-text-secondary);\n}\n\n.routes-modal__spinner {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: 4px solid var(--cfn-spinner-track);\n  border-top-color: var(--cfn-spinner-fill);\n  animation: routes-modal-spin 1s linear infinite;\n}\n\n@keyframes routes-modal-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Error State */\n.routes-modal__error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  gap: 1rem;\n  color: var(--cfn-danger-text);\n  text-align: center;\n}\n\n.routes-modal__error-icon {\n  opacity: 0.5;\n  flex-shrink: 0;\n}\n\n.routes-modal__retry-btn {\n  margin-top: 0.5rem;\n  padding: 0.5rem 1.25rem;\n  background: var(--cfn-danger-muted);\n  border: 1px solid var(--cfn-danger);\n  border-radius: 6px;\n  color: var(--cfn-danger-text);\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.routes-modal__retry-btn:hover {\n  background: var(--cfn-btn-danger-hover-bg);\n}\n\n/* Empty State */\n.routes-modal__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  gap: 1rem;\n  color: var(--cfn-text-muted);\n  text-align: center;\n}\n\n.routes-modal__empty-icon {\n  opacity: 0.5;\n  flex-shrink: 0;\n}\n\n/* Table */\n.routes-modal__table-wrapper {\n  overflow-x: auto;\n}\n\n.routes-modal__table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.routes-modal__table thead {\n  background: var(--cfn-table-header-bg);\n  border-bottom: 2px solid var(--cfn-border);\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.routes-modal__table th {\n  padding: 0.875rem 1.25rem;\n  text-align: left;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--cfn-text-secondary);\n}\n\n.routes-modal__table tbody tr {\n  border-bottom: 1px solid var(--cfn-border-muted);\n  transition: background 0.15s ease;\n}\n\n.routes-modal__table tbody tr:hover {\n  background: var(--cfn-table-row-hover);\n}\n\n.routes-modal__table td {\n  padding: 1rem 1.25rem;\n  color: var(--cfn-text-secondary);\n  font-size: 0.9375rem;\n}\n\n.routes-modal__ref {\n  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\n  font-weight: 600;\n  color: var(--cfn-accent-primary-text);\n}\n\n.routes-modal__description {\n  color: var(--cfn-text-secondary);\n}\n\n.routes-modal__actions-col {\n  width: 200px;\n  text-align: right;\n}\n\n/* Action Buttons */\n.routes-modal__actions {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: flex-end;\n}\n\n.routes-modal__action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid transparent;\n}\n\n.routes-modal__action-btn svg {\n  flex-shrink: 0;\n}\n\n.routes-modal__spinner-icon {\n  animation: routes-modal-spin 1s linear infinite;\n}\n\n.routes-modal__action-btn--edit {\n  background: var(--cfn-accent-primary-muted);\n  border-color: var(--cfn-accent-primary);\n  color: var(--cfn-accent-primary-text);\n}\n\n.routes-modal__action-btn--edit:hover {\n  background: var(--cfn-btn-primary-hover-bg);\n  transform: translateY(-1px);\n  box-shadow: var(--cfn-shadow-md);\n}\n\n.routes-modal__action-btn--add {\n  background: var(--cfn-success-muted);\n  border-color: var(--cfn-success);\n  color: var(--cfn-success-text);\n}\n\n.routes-modal__action-btn--add:hover {\n  background: rgba(16, 185, 129, 0.3);\n  transform: translateY(-1px);\n  box-shadow: var(--cfn-shadow-md);\n}\n\n.routes-modal__action-btn--on-map {\n  background: var(--cfn-bg-tertiary);\n  border-color: var(--cfn-border-muted);\n  color: var(--cfn-text-muted);\n  cursor: default;\n}\n\n.routes-modal__action-btn--on-map:hover {\n  transform: none;\n  box-shadow: none;\n  background: var(--cfn-bg-tertiary);\n}\n\n/* Footer & Pagination */\n.routes-modal__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid var(--cfn-border-muted);\n  background: var(--cfn-modal-footer-bg);\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.routes-modal__pagination-info {\n  font-size: 0.875rem;\n  color: var(--cfn-text-muted);\n}\n\n.routes-modal__pagination {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.routes-modal__page-btn {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--cfn-input-bg);\n  border: 1px solid var(--cfn-border);\n  border-radius: 6px;\n  color: var(--cfn-text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.routes-modal__page-btn:hover:not(:disabled) {\n  background: var(--cfn-accent-primary-muted);\n  border-color: var(--cfn-accent-primary);\n  color: var(--cfn-text-primary);\n}\n\n.routes-modal__page-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.routes-modal__page-numbers {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.routes-modal__page-number {\n  min-width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0.5rem;\n  background: var(--cfn-input-bg);\n  border: 1px solid var(--cfn-border);\n  border-radius: 6px;\n  color: var(--cfn-text-secondary);\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.routes-modal__page-number:hover:not(.routes-modal__page-number--active) {\n  background: var(--cfn-accent-primary-muted);\n  border-color: var(--cfn-accent-primary);\n}\n\n.routes-modal__page-number--active {\n  background: var(--cfn-btn-primary-bg);\n  border-color: var(--cfn-accent-primary);\n  color: var(--cfn-btn-primary-text);\n  cursor: default;\n}\n\n.routes-modal__page-ellipsis {\n  padding: 0 0.25rem;\n  color: var(--cfn-text-disabled);\n  font-size: 0.875rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .routes-modal {\n    max-height: 90vh;\n    width: 100%;\n  }\n\n  .routes-modal__table th,\n  .routes-modal__table td {\n    padding: 0.75rem 1rem;\n    font-size: 0.875rem;\n  }\n\n  .routes-modal__actions {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .routes-modal__action-btn {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .routes-modal__footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .routes-modal__pagination {\n    justify-content: center;\n  }\n\n  .routes-modal__pagination-info {\n    text-align: center;\n  }\n}\n\n/* Short landscape: bound the routes modal to the real viewport. The body\n   (.routes-modal__body) already scrolls, so this just keeps it fully on-screen. */\n@media (orientation: landscape) and (max-height: 600px) {\n  .routes-modal {\n    max-height: calc(var(--app-height, 100dvh) - 20px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
